export default __webpack_public_path__ + "static/christmas-carols-9dcce881981c04544133783cdb486004.png";